export interface NavItem {
  id: string;
  path: string;
  label: string;
  icon: string;
}

export interface NavSection {
  // Undefined label = a header-less anchor group (Dashboard).
  label?: string;
  items: NavItem[];
}

// Sidebar sections. Dashboard is the lone header-less anchor; the rest are
// grouped by mental model: outward-facing engagements (Workspace), the
// workforce that delivers them (Workforce), and app configuration (System).
export const NAV_SECTIONS: NavSection[] = [
  {
    items: [{ id: 'dashboard', path: '/dashboard', label: 'Dashboard', icon: 'space_dashboard' }],
  },
  {
    label: 'Workspace',
    items: [
      { id: 'clients', path: '/clients', label: 'Clients', icon: 'apartment' },
      { id: 'projects', path: '/projects', label: 'Projects', icon: 'view_kanban' },
      { id: 'invoices', path: '/invoices', label: 'Invoices', icon: 'receipt_long' },
    ],
  },
  {
    label: 'Workforce',
    items: [
      { id: 'people', path: '/people', label: 'Staff', icon: 'groups' },
      { id: 'teams', path: '/teams', label: 'Teams', icon: 'diversity_3' },
      { id: 'assignments', path: '/assignments', label: 'Assignments', icon: 'distance' },
      { id: 'onboarding', path: '/onboarding', label: 'Onboarding', icon: 'how_to_reg' },
    ],
  },
  {
    label: 'System',
    items: [
      { id: 'data', path: '/data', label: 'Data points', icon: 'tune' },
      { id: 'email', path: '/email', label: 'Email', icon: 'mail' },
      { id: 'settings', path: '/settings', label: 'Settings', icon: 'settings' },
    ],
  },
];

export const VIEW_TITLES: Record<string, [string, string]> = {
  dashboard: ['Dashboard', 'here’s where things stand'],
  projects: ['Projects', 'Kanban board across all active engagements'],
  people: ['Staff', 'Staff & contractor directory'],
  teams: ['Teams', 'Group staff for fast assignment'],
  clients: ['Clients', 'Client organizations & engagements'],
  assignments: ['Assignments', 'Match staff to locations by proximity'],
  onboarding: ['Onboarding & offboarding', 'Lifecycle for FTEs and contractors'],
  invoices: ['Invoices', 'Submitted by contractors — review & approve'],
  data: ['Data points', 'Manage selector values used across CCSilo'],
  profile: ['My profile', 'Your details, payment info & submissions'],
  settings: ['Settings', 'Organization, access & integrations'],
  email: ['Email', 'Templates & automated triggers'],
};
